/* eslint-disable no-useless-computed-key */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useCallback, useRef } from 'react';
import customStyles from "../../../../../assets/styles/customStyles";
import MainHeader from "../../../../Shared/components/Header";
import PrimaryCard from "../../../../Shared/components/Card/PrimaryCard";
import SalesIcon from "../../../../../assets/images/icon_menus/SalesIcon.json";
import clsx from 'clsx';
import { Row, Col, Image, Space } from "antd";
import ExportIcon from "../../../../../assets/images/icon_actions/Export.svg";
import SearchIcon from "../../../../../assets/images/icon_actions/Search Icon.svg";
import { useParams, NavLink } from "react-router-dom";
import { TextField } from "@mui/material";
import FilterIcon from "../../../../../assets/images/icon_actions/Filter Icon.svg";
import { CustomerTransactionTable } from "./CustomerTransaction"
import { DesktopDatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import DateIcon from "../../../../Shared/components/Icons/Date";
import { useDispatch, useSelector } from "react-redux";
import managementActions from "../../../Management/redux/actions";
import usePrevious from "../../../../Shared/components/Previous";
import actions from "../../redux/actions";
import DropDown from "../../../../../assets/images/icon_menus/Drop Down.svg";
import DropUp from "../../../../../assets/images/icon_menus/Drop Up.svg";
//import Down from "../../../../Shared/components/Icons/Down";
import moment from 'moment';
import { FilterSelect } from "../../../../Shared/components/CustomSelect";
import crudActions from "../../../../CRUD/redux/actions";
import { ImportExport } from '../../../../Shared/components/ImportExport';
import { checkComponentPermission, checkViewPermission, idNamingConversion } from '../../../../../helpers/utilities';
import dayjs from 'dayjs';
import { AESDecrypt } from "../../../../../helpers/Crypto";
import { AutoCompleteComponent } from "../../../../Shared/components/AutoCompleteComponent";
import FilterReset from "../../../../../assets/images/icon_actions/FilterReset.svg";
import ClearIcon from "../../../../../assets/images/icon_actions/Clear Icon.svg";


const CustomerTransactions = (props) => {
    const { customerDetails, loader } = useSelector(state => state.salesManagementReducer);;
    const { getList, getData } = useSelector(state => state.crudReducer);
    const dispatch = useDispatch();
    let { customerTransactionID } = useParams();
    const decryptedId = AESDecrypt(customerTransactionID);
    const [customerId, setCustomerId] = useState(customerTransactionID ? parseInt(decryptedId) : '');
    const [sortBy, setSortBy] = useState("id");
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [sortOrder, setSortOrder] = useState("desc");
    const [skip, setSkip] = useState(0);
    const [picker, setPicker] = useState(false);
    const [dateValue, setDateValue] = useState([null, null]);
    const limit = 25;
    const [search, setSearch] = useState('');
    const [iconAnimation, setIconAnimation] = useState(false);
    const timeoutRef = useRef(null);
    // const searchInput = useRef(null);
    const prevSearch = usePrevious(search);
    const [dataStatus, setDataStatus] = useState("");
    const [loadMore, setLoadMore] = useState(false);
    const [loadMoreContent, setLoadMoreContent] = useState(false);
    const prevGetData = usePrevious(getData);
    const [importVisible, setImportVisible] = useState(false);
    const { roleManagement } = useSelector(state => state.authReducer);
    const { history } = props;

    useEffect(() => {
        if ((prevSearch !== undefined && search && search.length > 2 && prevSearch !== search) || (prevSearch !== undefined && search === '' && prevSearch !== search)) {
            if (timeoutRef.current !== null) {
                clearTimeout(timeoutRef.current);
            }
            if (search === '') {
                dispatchFillter(customerId, dateValue, dataStatus, sortBy, sortOrder);
            } else {
                timeoutRef.current = setTimeout(() => {
                    dispatchFillter(customerId, dateValue, dataStatus, sortBy, sortOrder);
                }, 500);
            }
        }
    }, [search]);

    useEffect(() => {
        if (roleManagement !== '' && checkViewPermission('Customer Transactions', history, 'Sales')) {
            loadTasks();
        }
    }, [roleManagement]);

    useEffect(() => {
        if (loadMore && getData === '') {
            setLoadMoreContent(false);
            setLoadMore(true);
        }
        if (prevGetData !== undefined && getData && prevGetData !== getData) {
            const timer = setTimeout(() => {
                if (getData && Array.isArray(getData) && getData.length > 0) {
                    setLoadMore(true);
                    if (getData.length < limit) {
                        setLoadMoreContent(false);
                    } else {
                        setLoadMoreContent(true);
                    }
                } else {
                    setLoadMoreContent(false);
                    setLoadMore(true);
                }
            });

            return () => {
                clearTimeout(timer);
            };
        }
    }, [getData]);

    const customerObject = () => {
        let a = customerDetails && customerDetails.filter(function (el) { return el.id === parseInt(customerId) });
        if (a && a?.length !== 0) {
            return a[0];
        }
        return [];
    }

    const loadTasks = useCallback(() => {
        dispatch({
            type: managementActions.CUSTOMER_DETAILS_START, url: 'customerProfile', filter: {
                order: 'id desc'
            }
        });
        dispatchFillter(customerId, dateValue, dataStatus, sortBy, sortOrder);
    });

    const dispatchFillter = (customerId, dateValue, dataStatus, sortBy, sortOrder, skip = 0) => {
        if (skip === 0) {
            setLoadMore(false);
            setLoadMoreContent(false);
        }
        let filter = { ["and"]: [] };
        let or = { ["or"]: [] };
        if (customerId !== '') {
            filter['and'].push({ customerId: customerId });
        }
        if (search !== '') {
            or['or'].push({ type: { like: '%' + search.trim() + '%' } });
            or['or'].push({ amount: { like: '%' + search.trim() + '%' } });
            or['or'].push({ balance: { like: '%' + search.trim() + '%' } });
        }
        if (dateValue[0] !== null && dateValue[1] !== null) {
            filter['and'].push({ date: { between: [dayjs(dateValue[0]).format('YYYY-MM-DD'), dayjs(dateValue[1]).format('YYYY-MM-DD')] } });

        }
        if (dataStatus !== '') {
            filter['and'].push({ closed: dataStatus === 'open' ? false : true });
        }
        if (or.or.length > 0) {
            filter['and'].push(or);
        }
        setSkip(skip);
        dispatch({
            type: crudActions.GET_DETAILS_START,
            url: 'customerTransaction',
            skip: skip,
            filter: {
                where: !filter.and || filter.and.length === 0 ? {} : filter,
                order: sortBy + ' ' + sortOrder,
                limit: limit,
                skip: skip,
            }
        })
    }

    const handleDates = (value, reset = false) => {
        setDateValue(value);
        if ((value[0] !== null && value[1] !== null) || reset) {
            dispatchFillter(customerId, value, dataStatus, sortBy, sortOrder);
        }
    }

    const handleChangeCustomer = (value) => {
        setCustomerId(value);
        dispatchFillter(value, dateValue, dataStatus, sortBy, sortOrder);
    }

    const requestSort = (sortBy, sortOrder) => {
        setSortBy(sortBy);
        setSortOrder(sortOrder);
        dispatchFillter(customerId, dateValue, dataStatus, sortBy, sortOrder);
    }

    const handleStatus = (value) => {
        setDataStatus(value);
        dispatchFillter(customerId, dateValue, value, sortBy, sortOrder);
    }

    const handlePicker = (picker) => {
        setPicker(picker);
        setStartDate(null);
        setEndDate(null);
        if (!picker) {
            handleDates([null, null], true);
        }
    }

    const loadMoreTask = () => {
        let s = skip + limit;
        dispatchFillter(customerId, dateValue, dataStatus, sortBy, sortOrder, s);
    }

    const loadImportExportData = (name, data = 'existing', selected = [], extension = 'xlsx') => {
        let filter = { ["and"]: [] };
        let or = { ["or"]: [] };
        if (customerId !== '') {
            filter['and'].push({ customerId: customerId });
        }
        if (search !== '') {
            or['or'].push({ type: { like: '%' + search.trim() + '%' } });
            or['or'].push({ amount: { like: '%' + search.trim() + '%' } });
            or['or'].push({ balance: { like: '%' + search.trim() + '%' } });
        }
        if (dateValue[0] !== null && dateValue[1] !== null) {
            filter['and'].push({ date: { between: [dayjs(dateValue[0]).format('YYYY-MM-DD'), dayjs(dateValue[1]).format('YYYY-MM-DD')] } });

        }
        if (dataStatus !== '') {
            filter['and'].push({ closed: dataStatus === 'open' ? false : true });
        }
        filter['and'].push(or);
        dispatch({
            type: actions.SALES_TRANSACTION_DETAILS_START,
            export: name,
            data: data,
            selected: selected,
            extension: extension,
            url: 'customerTransaction',
            filter: {
                where: filter,
                order: sortBy + ' ' + sortOrder,
            }
        });
    }

    // const handleChange = (e) => {
    //     if (e.target.value === '') {
    //         handleChangeCustomer('');
    //     }
    // }

    const classes = customStyles();
    return (
        <React.Fragment>
            <MainHeader  {...props} cls={'newImg'} img={SalesIcon} title={'Sales'} links={[{ 'label': 'Sales', 'link': '/sales' }, { 'label': 'Customer Transactions', 'link': '' }]} />
            <div className={clsx(classes.margin40, classes.listTableMargin)}>
                <PrimaryCard
                    title={'Customer Transactions'}
                    component={
                        <>
                            <Row className={clsx(classes.marginBottom20)}>
                                <Col xxl={6} xl={7} lg={8} md={10} sm={14} xs={24}>
                                    {
                                        roleManagement !== '' && checkComponentPermission('Customer Transactions', 'Action', 'Search') &&
                                        <div className={clsx(classes.searchAnimation, { [classes.iconAnimation]: iconAnimation || search !== '' })}>
                                            <TextField autoComplete='one-time-code'
                                                placeholder='Search Trans. Type, Amount, and Balance'
                                                type='search'
                                                value={search}
                                                className={classes.comInput}
                                                onChange={(e) => setSearch(e.target.value)}
                                                variant={'standard'}
                                                fullWidth
                                                id={idNamingConversion('Search', 'customerTransactions', 'TextField')}
                                                onFocus={() => setIconAnimation(true)}
                                                onBlur={() => setIconAnimation(false)}
                                            />
                                            <Image
                                                src={SearchIcon}
                                                preview={false}
                                            />
                                            {
                                                search && <NavLink to="#" onClick={() => setSearch('')} className={classes.searchClear}>
                                                    <Image
                                                        src={ClearIcon}
                                                        preview={false}
                                                    />
                                                </NavLink>
                                            }
                                        </div>
                                    }
                                </Col>
                                <Col xxl={18} xl={17} lg={16} md={14} sm={10} xs={24} className={clsx(classes.textAlignRight, classes.removeUnderline, classes.vertiCalScrollOverFlowParent, classes.customerLabelNone)}>
                                    <div className={clsx(classes.vertiCalScrollOverFlow, classes.customFilterTransaction)}>
                                        <Space size={[20, 20]} direction="horizontal" align="center">
                                            {
                                                roleManagement !== '' &&
                                                (checkComponentPermission('Customer Transactions', 'Action', 'All Customer') ||
                                                    checkComponentPermission('Customer Transactions', 'Page', 'Date Filter')) && <>
                                                    <NavLink
                                                        to="#"
                                                        className={clsx(classes.customLink, classes.customFilter)}>
                                                        {
                                                            customerId || (startDate && endDate) ?
                                                                <>
                                                                    <Image
                                                                        src={FilterReset}
                                                                        preview={false}
                                                                        className={clsx(classes.antImage)}
                                                                    /> <span className={clsx(classes.addLink, classes.color, classes.bold, classes.fwMedium)}>Reset Filter</span>
                                                                </> : <>
                                                                    <Image
                                                                        src={FilterIcon}
                                                                        preview={false}
                                                                        className={clsx(classes.antImage)}
                                                                    /> <span className={clsx(classes.addLink, classes.color, classes.bold, classes.fwMedium)}>Filter</span>
                                                                </>
                                                        }
                                                    </NavLink>
                                                </>
                                            }
                                            {
                                                roleManagement !== '' && checkComponentPermission('Customer Transactions', 'Action', 'All Customer') &&
                                                <AutoCompleteComponent
                                                    customLabel={"All Customers "}
                                                    heads={[{ 'key': 'name', 'name': 'Name' }]}
                                                    details={customerDetails}
                                                    customClasses={classes.customWidth172P}
                                                    position={"bottom"}
                                                    variant={'outlined'}
                                                    id={idNamingConversion('All Customers', 'customerTransactions', 'DropDown')}
                                                    parentValue={customerObject()}
                                                    onChangeText={(data) => {
                                                        if (data === '') {
                                                            handleChangeCustomer(data);
                                                        }
                                                    }}
                                                    onChange={(data) => handleChangeCustomer(data.id)}
                                                />
                                            }
                                            {
                                                roleManagement !== '' && checkComponentPermission('Customer Transactions', 'Action', 'Date Filter') &&
                                                <div className={clsx(classes.dateFilterwidth, classes.width250)}>
                                                    <Row>
                                                        <Col span={24}>
                                                            <NavLink to={'#'} id={idNamingConversion('Date Filter', 'customerTransactions', 'Link')} onClick={() => handlePicker(!picker)} className={clsx(classes.textAlignLeft, classes.dateFilter, classes.dropDownBorder, classes.dropDownWidth, classes.margint0, classes.dropDownPointer)}>
                                                                Date Filter <Image
                                                                    src={picker ? DropUp : DropDown}
                                                                    preview={false}
                                                                />
                                                            </NavLink>
                                                        </Col>
                                                        {
                                                            picker && <Col span={24}>
                                                                <div className={clsx(classes.dateFilterdateAdjust)}>
                                                                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                                                                        <DesktopDatePicker
                                                                            fullWidth
                                                                            slots={{
                                                                                openPickerIcon: DateIcon
                                                                            }}
                                                                            views={['year', 'month', 'day']}
                                                                            allowKeyboardControl={false}
                                                                            value={startDate}
                                                                            label="From Date"
                                                                            InputProps={{
                                                                                classes: {
                                                                                    input: classes.textFieldColor
                                                                                },
                                                                                //inputProps: { value: moment(startDate).format('DD/MM/YYYY'), readOnly: false }
                                                                            }}
                                                                            format="dd/MM/yyyy"
                                                                            onChange={(newValue) => {
                                                                                handleDates([moment(newValue).format("YYYY-MM-DD"), endDate]);
                                                                                setStartDate(newValue);
                                                                            }}
                                                                            slotProps={{
                                                                                textField: {
                                                                                    id: idNamingConversion('From Date', 'customerTransactions', 'TextField'),
                                                                                    autoComplete: 'one-time-code'
                                                                                },
                                                                            }}
                                                                        />
                                                                    </LocalizationProvider>
                                                                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                                                                        <DesktopDatePicker
                                                                            fullWidth
                                                                            slots={{
                                                                                openPickerIcon: DateIcon
                                                                            }}
                                                                            views={['year', 'month', 'day']}
                                                                            allowKeyboardControl={false}
                                                                            value={endDate}
                                                                            minDate={new Date(startDate)}
                                                                            label="To Date"
                                                                            InputProps={{
                                                                                classes: {
                                                                                    input: classes.textFieldColor
                                                                                },
                                                                                //inputProps: { value: moment(endDate).format('DD/MM/YYYY'), readOnly: false }
                                                                            }}
                                                                            format="dd/MM/yyyy"
                                                                            onChange={(newValue) => {
                                                                                handleDates([startDate, moment(newValue).format("YYYY-MM-DD")]);
                                                                                setEndDate(newValue);
                                                                            }}
                                                                            slotProps={{
                                                                                textField: {
                                                                                    id: idNamingConversion('To Date', 'customerTransactions', 'TextField'),
                                                                                    autoComplete: 'one-time-code'
                                                                                },
                                                                            }}
                                                                        />
                                                                    </LocalizationProvider>
                                                                </div>
                                                            </Col>
                                                        }
                                                    </Row>
                                                </div>
                                            }
                                            {
                                                roleManagement !== '' && checkComponentPermission('Customer Transactions', 'Action', 'All') &&
                                                <FilterSelect
                                                    parentClasses={clsx(classes.dateFilterwidth, classes.width125)}
                                                    customClasses={clsx(classes.dropDownBorder, classes.dropDownWidth, classes.margint0, classes.dropDownPointer)}
                                                    details={[{ slug: "", label: "All" }, { slug: "closed", label: "Closed" }, { slug: "open", label: "Open" }]}
                                                    onChange={(e) => handleStatus(e.target.value)}
                                                    defaultValue={dataStatus}
                                                    id={idNamingConversion('All', 'customerTransactions', 'DropDown')}
                                                    heads={['slug', 'label']}
                                                />
                                            }
                                            {
                                                roleManagement !== '' && checkComponentPermission('Customer Transactions', 'Action', 'Export') &&
                                                <NavLink
                                                    to="#"
                                                    onClick={() => { loadImportExportData('CustomerTransactions'); }}
                                                    id={idNamingConversion('Export', 'customerTransactions', 'Link')}
                                                    className={clsx(classes.customLink)}>
                                                    <Image
                                                        src={ExportIcon}
                                                        preview={false}
                                                        className={clsx(classes.antImage)}
                                                    /> <span className={clsx(classes.addLink, classes.color, classes.bold)}>Export</span>
                                                </NavLink>
                                            }
                                            {
                                                roleManagement !== '' && checkComponentPermission('Customer Transactions', 'Action', 'Filter') &&
                                                <></>
                                            }
                                        </Space>
                                    </div>
                                </Col>
                            </Row>
                            <CustomerTransactionTable
                                search={search}
                                customerId={customerId}
                                dateValue={dateValue}
                                dataStatus={dataStatus}
                                loadTasks={() => dispatchFillter(customerId, dateValue, dataStatus, sortBy, sortOrder)}
                                details={getList}
                                loadMore={loadMore}
                                loadMoreContent={loadMoreContent}
                                loadMoreTask={() => loadMoreTask()}
                                sortOrder={sortOrder}
                                sortBy={sortBy}
                                roleManagement={roleManagement}
                                onRequestSort={(sortBy, sortOrder) => requestSort(sortBy, sortOrder)} />
                        </>
                    }
                />
            </div>
            <ImportExport
                handleClose={() => { setImportVisible(false); }}
                visible={importVisible}
                title={'CustomerTransactions'}
                type={'import'}
                loader={loader}
                loadImportExportData={(name, type, selected, extension) => loadImportExportData(name, type, selected, extension)}
                details={customerDetails}
                loadTasks={() => { dispatchFillter(sortBy, sortOrder) }}
            />
        </React.Fragment>
    )
}
export default CustomerTransactions